import { IThConfig } from './Table';

export const getWidthStyles = (thConfig: IThConfig) => {
  let widthStyles: {
    width?: string;
    minWidth?: string;
    maxWidth?: string;
  } = {};

  if (thConfig.width) {
    const widthString =
      typeof thConfig.width === 'number'
        ? thConfig.width + 'px'
        : thConfig.width;

    if (thConfig.width === 'auto') {
      widthStyles = {
        width: widthString,
        minWidth: '40px',
      };

      // Обробляємо minWidth та maxWidth
      if (thConfig.minWidth) {
        widthStyles.minWidth =
          typeof thConfig.minWidth === 'number'
            ? thConfig.minWidth + 'px'
            : thConfig.minWidth;
      }
      if (thConfig.maxWidth) {
        widthStyles.maxWidth =
          typeof thConfig.maxWidth === 'number'
            ? thConfig.maxWidth + 'px'
            : thConfig.maxWidth;
      }
    } else {
      widthStyles = {
        width: widthString,
        maxWidth: widthString,
        minWidth: widthString,
      };
    }
  } else {
    // Обробляємо випадок, коли присутні лише minWidth або maxWidth
    if (thConfig.minWidth) {
      widthStyles.minWidth =
        typeof thConfig.minWidth === 'number'
          ? thConfig.minWidth + 'px'
          : thConfig.minWidth;
    }
    if (thConfig.maxWidth) {
      widthStyles.maxWidth =
        typeof thConfig.maxWidth === 'number'
          ? thConfig.maxWidth + 'px'
          : thConfig.maxWidth;
    }
  }

  return widthStyles;
};
